/* CatalogApp.js */
class CatalogApp {
    constructor(catalog, bootstrap) {
        this.catalog = catalog;
        this.bootstrap = bootstrap;
        this.container = null;
        this.baseUrl = null;

        this.init();
        this.initEventListeners();
        this.setupAppMethods();
    }

    /**
     * Initialize event listeners
     */
    initEventListeners() {
        document.addEventListener('catalog-cart-update', (event) => {
            const target = `appvimar://native/updateCartNum:${event.detail.quantity}`;
            window.location.href = target;
        });
    }

    /**
     * Setup application methods on the vimar app
     */
    setupAppMethods() {
        window.vimar = window.vimar || {};
        window.vimar.app = window.vimar.app || {};

        window.vimar.app.runSearch = (value) => {
            const term = encodeURIComponent(String(value));
            window.location.href = `${this.baseUrl}/search?term=${term}`;
        };

        window.vimar.app.dropCart = () => {
            this.showCart();
        };
    }

    /**
     * Open the cart inside the catalog WebView.
     */
    showCart() {
        const modalNode = document.querySelector('[data-catalog-namespace="catalog/cart/modal"]');
        if (!modalNode) {
            console.error('Catalog cart modal is missing from the app page.');
            return;
        }

        this.bootstrap.Modal.getOrCreateInstance(modalNode).show();
    }

    /**
     * Initialize the catalog app
     */
    init() {
        console.log('CatalogApp initialization');
        this.container = document.querySelector('[data-catalog-namespace="catalog"]');

        this.baseUrl = this.container ? this.container.getAttribute('data-catalog-baseurl') : null;

        if (!this.baseUrl) {
            console.error('Base URL is missing on the catalog container element.');
        }
    }
}

export default CatalogApp;
